export default __webpack_public_path__ + "static/media/404-graphicV2.60ad0d0b.png";